// Declare the global BX24 object and injected POST data
declare global {
  interface Window {
    BX24: any;
    __BX24_POST_DATA?: {
      AUTH_ID?: string;
      REFRESH_ID?: string;
      DOMAIN?: string;
      MEMBER_ID?: string;
      PLACEMENT?: string;
      PLACEMENT_OPTIONS?: string;
      [key: string]: any;
    };
  }
}

export interface BxAuthData {
  access_token: string;
  refresh_token: string;
  domain: string;
  member_id?: string;
}

export const initBx24 = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.BX24) {
      window.BX24.init(() => {
        resolve();
      });
    } else {
      // Fallback for development outside Bitrix frame (Optional)
      console.warn("BX24 object not found. Ensure you are running inside Bitrix24.");
      // We resolve anyway to allow the app to try loading with injected data if available
      resolve();
    }
  });
};

export const getBxAuth = (): BxAuthData | null => {
  // Priority 1: Try standard BX24.getAuth()
  if (window.BX24) {
    const auth = window.BX24.getAuth();
    if (auth && auth.access_token) {
      return {
        access_token: auth.access_token,
        refresh_token: auth.refresh_token,
        domain: auth.domain,
        member_id: auth.member_id,
      };
    }
  }

  // Priority 2: Check for data injected via POST middleware (if using the injection method)
  if (window.__BX24_POST_DATA && window.__BX24_POST_DATA.AUTH_ID) {
    return {
      access_token: window.__BX24_POST_DATA.AUTH_ID,
      refresh_token: window.__BX24_POST_DATA.REFRESH_ID || '',
      domain: window.__BX24_POST_DATA.DOMAIN || '',
      member_id: window.__BX24_POST_DATA.MEMBER_ID,
    };
  }

  // Priority 3: Check URL Search Params (GET request via Redirect)
  // This handles the case where we 303 Redirect POST -> GET with params
  const query = new URLSearchParams(window.location.search);
  if (query.get('AUTH_ID')) {
      return {
          access_token: query.get('AUTH_ID')!,
          refresh_token: query.get('REFRESH_ID') || '',
          domain: query.get('DOMAIN') || '',
          member_id: query.get('MEMBER_ID') || undefined,
      };
  }

  return null;
};

export const fitWindow = () => {
    if(window.BX24) {
        window.BX24.fitWindow();
    }
}